import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/search',
    name: 'SearchPage',
    component: () => import('../views/Search.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('../views/mine/Mine.vue')
  },
  {
    path: '/tvplay-page',
    name: 'TVplayPage',
    component: () => import('../views/TVplayPage.vue')
  },
  {
    path: '/tvPlayAuto-page',
    name: 'YouKuPlayPage',
    component: () => import('../views/YouKuPlayPage.vue')
  },
  {
    path: '/download-detail',
    name: 'DownloadDetailPage',
    component: () => import('../views/DownloadDetailPage.vue')
  },
  {
    path: '/special-page',
    name: 'SpecialPage',
    component: () => import('../views/SpecialPage.vue')
  },
  {
    path: '/rich-page',
    name: 'RichPage',
    component: () => import('../views/RichPage.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/open-auth-redirect-target',
    name: 'OpenAuthRedirectTarget',
    component: () => import('../views/OpenAuthRedirectTarget.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
